import { apiFetch } from "../fetchApi";

export const createClient = async (BeURL, showAlert, payload, setClient) => {
    try {
        // 2️⃣ Send companyId as query param for account creation
        const accountRes = await apiFetch(`${BeURL}/create-client`, {
            method: "POST",

            body: JSON.stringify(payload), // FormData (images/files)
        });

        const accountData = await accountRes.json();
        if (!accountData.success) {
            showAlert(accountData.message);
            return;
        }

        showAlert(accountData.message);
        setClient({
            companyName: "",
            companyWebsite: '',
            industry: '',
            active: true
        })


    } catch (err) {
        console.error("Error in Client create:", err);
        alert('Trouble connecting to the server! Please try again later.');
    }
};

export const fetchClient = async (BeURL, showAlert, setClient, clientId) => {
    try {
        // 2️⃣ Send companyId as param for get manager Ids creation
        const res = await apiFetch(`${BeURL}/clientData/${clientId}`, {
            method: "GET",
        });

        const data = await res.json();
        if (!data.success) {
            showAlert(data.message);
            return;
        }

        setClient(data.clientData)


    } catch (err) {
        console.error("Error in Fetch All Users:", err);
        alert('Trouble connecting to the server! Please try again later.');
    }
}

export const fetchAllClient = async (BeURL, showAlert, setClient, companyId, currentPage, rowsPerPage, setTotalClient, setTotalPage) => {
    try {
        // 2️⃣ Send companyId as param for get manager Ids creation
        const res = await apiFetch(`${BeURL}/client/companyClient/${companyId}`, {
            method: "POST",
            body: JSON.stringify({ pages: currentPage, clientPerPage: rowsPerPage })
        });

        const data = await res.json();

        if (!data.success) {
            showAlert(data.message);
            return;
        }

        setClient(data.companyClient)
        setTotalClient(data.totalClient)
        setTotalPage(data.totalPages)


    } catch (err) {
        console.error("Error in Fetch All Users:", err);
        alert('Trouble connecting to the server! Please try again later.');
    }
}

export const updateClient = async (BeURL, showAlert, payload, setClient, clientId, companyId, navigate) => {
    try {


        // 2️⃣ Send companyId as query param for account creation
        const accountRes = await apiFetch(`${BeURL}/update-client/${clientId}/${companyId}`, {
            method: "POST",

            body: JSON.stringify(payload), // FormData (images/files)
        });

        const accountData = await accountRes.json();
        if (!accountData.success) {
            showAlert(accountData.message);
            return;
        }

        showAlert(accountData.message);
        setClient({
            clientName: "",
            clientWebsite: '',
            industry: '',
            isActive: true
        })
        navigate('/list-clients')


    } catch (err) {
        console.error("Error in Client create:", err);
        alert('Trouble connecting to the server! Please try again later.');
    }
};


export const deleteConfirm = async (BeURL, showDeleteConfirm, showAlert, clientId) => {
    try {
        // 2️⃣ Send companyId as param for get manager Ids creation
        const res = await apiFetch(`${BeURL}/delete-client/${clientId}/confirm`, {
            method: "GET",
        });

        const data = await res.json();
        if (!data.success) {
            showAlert(data.message);
            return;
        }

        const confirmed = await showDeleteConfirm(data.message);
        return confirmed;


    } catch (err) {
        console.error("Error in Delete client confrimation:", err);
        alert('Trouble connecting to the server! Please try again later.');
    }
}

export const deleteClient = async (BeURL, showAlert, clientId) => {
    try {
        // 2️⃣ Send companyId as param for get manager Ids creation
        const res = await apiFetch(`${BeURL}/delete-client/${clientId}`, {
            method: "delete",
        });

        const data = await res.json();
        if (!data.success) {
            showAlert(data.message);
            return;
        }

        showAlert(data.message)
        window.location.reload()


    } catch (err) {
        console.error("Error in Delete client :", err);
        alert('Trouble connecting to the server! Please try again later.');
    }
}

export const fetchClients = async (BeURL, showAlert, setClientsList, companyId) => {
    try {
        // 2️⃣ Send companyId as param for get manager Ids creation
        const res = await apiFetch(`${BeURL}/companyClients/${companyId}`, {
            method: "GET",
        });

        const data = await res.json();
        if (!data.success) {
            showAlert(data.message);
            return;
        }

        setClientsList(data.companyClient)


    } catch (err) {
        console.error("Error in Fetch All Users:", err);
        alert('Trouble connecting to the server! Please try again later.');
    }
}